const TITLE_TAB_SCROLL_PADDING_PX = 14;

const getTitleTabScrollLeft = (
  scrollContainer: HTMLDivElement,
  activeTab: HTMLElement
): number => {
  const maxScrollLeft =
    scrollContainer.scrollWidth - scrollContainer.clientWidth;
  const tabLeft = activeTab.offsetLeft;
  const tabRight = tabLeft + activeTab.offsetWidth;
  const viewLeft = scrollContainer.scrollLeft;
  const viewRight = viewLeft + scrollContainer.clientWidth;

  let nextScrollLeft = viewLeft;

  if (tabRight + TITLE_TAB_SCROLL_PADDING_PX > viewRight) {
    nextScrollLeft =
      tabRight + TITLE_TAB_SCROLL_PADDING_PX - scrollContainer.clientWidth;
  } else if (tabLeft - TITLE_TAB_SCROLL_PADDING_PX < viewLeft) {
    nextScrollLeft = tabLeft - TITLE_TAB_SCROLL_PADDING_PX;
  }

  return Math.max(0, Math.min(nextScrollLeft, maxScrollLeft));
};

export { getTitleTabScrollLeft, TITLE_TAB_SCROLL_PADDING_PX };
